// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__YeV+d","loader":"Loader_loader__fjtQx","animloader":"Loader_animloader__bMaId"};